import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  LOGIN_FAIL,
  SESSION_TIMEOUT,
  SESSION_TIMEOUT_SUCCESS,
  SESSION_TIMEOUT_FAIL,
  OTP,
  OTP_SUCCESS,
  OTP_FAIL,
  RESET_STATE,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const loginFail = user => {
  return {
    type: LOGIN_FAIL,
    payload: user,
  }
}

export const otp = (data, history) => {
  return {
    type: OTP,
    payload: { data, history },
  }
}

export const otpSucess = data => {
  return {
    type: OTP_SUCCESS,
    payload: data,
  }
}

export const otpFail = error => {
  return {
    type: OTP_FAIL,
    payload: error,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

export const sessionTimeout = user => ({
  type: SESSION_TIMEOUT,
  payload: user,
})
export const sessionTimeoutSuccess = user => ({
  type: SESSION_TIMEOUT_SUCCESS,
  payload: user,
})
export const sessionTimeouFail = user => ({
  type: SESSION_TIMEOUT_FAIL,
  payload: user,
})

export const resetState = () => ({
  type: RESET_STATE,
})
